import { useState } from 'react';

import withAuth from 'hocs/withAuth/withAuth';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

import { useRequest, useOnInit } from 'hooks';
import { getStrapiJWTToken, getPageContent } from 'services';
import {
  PageType,
  FormPageTypeEnum,
  PageTypeEnum,
} from 'services/programs/types';

import { Loading, MarkdownContent, SecureIframe } from 'components';

import ContentHeader from './ContentHeader';
import * as S from './style';

const Content: React.FC = () => {
  const request = useRequest();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [page, setPage] = useState<PageType>();
  const [isFormType, setIsFormType] = useState(false);
  const formTypes: FormPageTypeEnum[] = [
    FormPageTypeEnum.ASSESSMENT,
    FormPageTypeEnum.QUIZ,
    FormPageTypeEnum.REFLECTION,
  ];

  const { pageId } = useParams<{
    pageId: string;
  }>();

  const goBackPrograms = () => {
    navigate(-1);
  };

  useOnInit(() => {
    const getPageContentByPageId = async () => {
      request.setLoading();
      try {
        const token = await getStrapiJWTToken();
        const response = await getPageContent(token, pageId || '');
        setPage(response);
        setIsFormType(formTypes.includes(response.page_type as PageTypeEnum));

        request.setSuccess();
      } catch (e) {
        request.setError(e);
      }
    };

    getPageContentByPageId();
  });

  const renderContent = (content: string): JSX.Element => {
    if (isFormType)
      return (
        <SecureIframe
          title="content"
          frameBorder="0"
          src={`https://${window.parent.location.host}/form/form/${content}?platform=care-provider`}
        />
      );

    return <MarkdownContent content={content} />;
  };

  return (
    <S.Content data-testid="content">
      <Loading isLoading={request.isLoading()} />
      {page && page?.title && (
        <ContentHeader
          topic={page?.topic?.title_key}
          title={page?.title}
          programName={state?.programName}
          onClickBackButton={goBackPrograms}
        />
      )}
      <S.ContentBody data-testid="content-body" isFormType={isFormType}>
        {page && page?.content && renderContent(page.content)}
      </S.ContentBody>
    </S.Content>
  );
};

export default withAuth(Content);
